var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KLogo',{attrs:{"altText":"Kolibri logo with background","size":120,"showBackground":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }